<!-- src/app/account/account.component.html -->
    <h1 class="mb-0 fw-bold mb-3">{{ 'USER_ACCOUNT.TITLE' | translate }}</h1>
    <div class="card shadow-lg">
        <div class="card-body">
            <!-- Formulaire d'informations personnelles -->
            <form>
                <h2 class="mb-4">{{ 'USER_ACCOUNT.PERSONAL_INFO' | translate }}</h2>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label for="firstName" class="form-label">{{ 'COMMON.FIRST_NAME' | translate }}</label>
                        <input 
                            type="text" 
                            class="form-control" 
                            id="firstName" 
                            [(ngModel)]="user.firstName" 
                            name="firstName"
                            [placeholder]="'COMMON.FIRST_NAME' | translate"
                        />
                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="lastName" class="form-label">{{ 'COMMON.LAST_NAME' | translate }}</label>
                        <input 
                            type="text" 
                            class="form-control" 
                            id="lastName" 
                            [(ngModel)]="user.lastName" 
                            name="lastName"
                            [placeholder]="'COMMON.LAST_NAME' | translate"
                        />
                    </div>
                </div>
                
                <div class="mb-3">
                    <label for="email" class="form-label">{{ 'COMMON.EMAIL' | translate }}</label>
                    <input 
                        type="email" 
                        class="form-control" 
                        id="email" 
                        [(ngModel)]="user.email" 
                        name="email"
                        [placeholder]="'COMMON.EMAIL' | translate"
                        disabled 
                    />
                </div>

                <hr class="my-4" />

                <!-- Paramètres de langue -->
                <div class="mb-4">
                    <h2 class="mb-4">{{ 'USER_ACCOUNT.LANGUAGE' | translate }}</h2>
                    <select 
                        class="form-select w-50" 
                        [(ngModel)]="user.languageCode" 
                        name="languageCode"
                        title="{{ 'USER_ACCOUNT.LANGUAGE' | translate }}"
                    >
                        @for (lang of availableLanguages; track lang) {
<option [ngValue]="lang.code">
                            {{ lang.name | translate }}
                        </option>
}
                    </select>
                </div>

                <!-- Boutons d'action -->
                <div class="d-flex justify-content-end gap-3">
                    <button 
                        type="button" 
                        class="btn btn-secondary" 
                        (click)="cancelChanges()"
                    >
                        {{ 'COMMON.CANCEL' | translate }}
                    </button>
                    <button 
                        type="submit" 
                        class="btn btn-primary" 
                        (click)="saveChanges()"
                    >
                        {{ 'COMMON.SAVE' | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>
